//import React from "react";
import { updateOrderStatus } from "../services/ordersApi";
import React, { useEffect, useState } from "react";

function OrderCard({ order, isHighlighted, reloadOrders }) {
  const handleUpdateStatus = async (newStatus) => {
    try {
      await updateOrderStatus(order.id, newStatus);

      console.log(`Orden ${order.id} actualizada a ${newStatus}`);

      if (reloadOrders) {
        await reloadOrders();
      }
    } catch (error) {
      console.error("Error actualizando estado:", error);
    }
  };

  const [visible, setVisible] = useState(false);
  const [elapsedTime, setElapsedTime] = useState("");

  const products = order.ticket_items || order.items || [];

  const drinkKeywords = ["coca", "sprite", "fanta", "agua", "pepsi"];

  const pizzaItems = products.filter((item) => {
    const productName = (
      item.name ||
      item.product_name ||
      item.product ||
      item.title ||
      ""
    ).toLowerCase();

    return !drinkKeywords.some((drink) => productName.includes(drink));
  });

  const drinkItems = products.filter((item) => {
    const productName = (
      item.name ||
      item.product_name ||
      item.product ||
      item.title ||
      ""
    ).toLowerCase();

    return drinkKeywords.some((drink) => productName.includes(drink));
  });

  useEffect(() => {
    setTimeout(() => setVisible(true), 50);
  }, []);

  // contador tiempo orden
  useEffect(() => {
    const toUtcDate = (s) => {
      if (!s) return null;
      if (s.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
      return new Date(s + "Z");
    };

    const updateElapsedTime = () => {
      let referenceDate = order.created_at;

      if (order.status === "PREPARING" && order.preparing_at) {
        referenceDate = order.preparing_at;
      }

      if (order.status === "READY" && order.ready_at) {
        referenceDate = order.ready_at;
      }

      const created = toUtcDate(referenceDate);
      const createdMs = created.getTime();
      const nowMs = Date.now();
      const diff = Math.max(0, Math.floor((nowMs - createdMs) / 1000));
      const minutes = Math.floor(diff / 60);
      const seconds = diff % 60;
      const formatted =
        `${String(minutes).padStart(2, "0")}:` +
        `${String(seconds).padStart(2, "0")}`;

      setElapsedTime(formatted);
    };

    // 🔥 ejecutar inmediatamente
    updateElapsedTime();

    // 🔥 luego actualizar cada segundo
    const interval = setInterval(updateElapsedTime, 1000);

    return () => clearInterval(interval);
  }, [order.created_at, order.preparing_at, order.ready_at, order.status]);

  const toUtcDate = (s) => {
    if (!s) return null;
    if (s.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
    return new Date(s + "Z");
  };

  let urgencyReferenceDate = order.created_at;
  if (order.status === "PREPARING" && order.preparing_at) {
    urgencyReferenceDate = order.preparing_at;
  }

  if (order.status === "READY" && order.ready_at) {
    urgencyReferenceDate = order.ready_at;
  }

  const created = toUtcDate(urgencyReferenceDate);
  const createdMs = created.getTime();
  const nowMs = Date.now();
  const diffMinutes = Math.max(0, Math.floor((nowMs - createdMs) / 1000 / 60));

  let urgencyColor = "#22c55e";
  let urgencyBg = "#dcfce7";

  if (diffMinutes >= 8) {
    urgencyColor = "#eab308";
    urgencyBg = "#fef9c3";
  }

  if (diffMinutes >= 15) {
    urgencyColor = "#ef4444";
    urgencyBg = "#fee2e2";
  }

  return (
    <div
      style={{
        border: isHighlighted
          ? "2px solid #22c55e"
          : `2px solid ${urgencyColor}`,
        borderRadius: 10,
        padding: 15,
        background: isHighlighted ? "#bbf7d0" : urgencyBg,
        boxShadow: isHighlighted ? "0 0 15px #22c55e" : "none",

        transform: visible
          ? "translateY(0px) scale(1)"
          : "translateY(-10px) scale(0.95)",

        transition: "all 0.3s ease",
      }}
    >
      <h3>Orden #{order.id}</h3>

      <p>
        <strong>Cliente:</strong> {order.customer}
      </p>

      <p>
        <strong>Total:</strong> ${order.total}
      </p>

      <p>
        <strong>Estado:</strong> {order.status}
      </p>

      <p
        style={{
          fontWeight: "bold",
          marginTop: 5,
          color: urgencyColor,
        }}
      >
        ⏱ {elapsedTime}
      </p>

      {/* TICKET */}
      <div style={{ marginTop: 10 }}>
        <strong>🧾 Ticket:</strong>

        {pizzaItems.length > 0 ? (
          <>
            {pizzaItems.map((item, index) => (
              <div
                key={index}
                style={{
                  marginLeft: 10,
                  padding: "6px 0",
                  borderBottom: "1px solid #eee",
                }}
              >
                <div>
                  {item.qty || item.quantity || 1}x{" "}
                  {item.name ||
                    item.product_name ||
                    item.product ||
                    item.title ||
                    "Producto"}
                  <span style={{ float: "right" }}>
                    ${(item.price || 0) * (item.qty || item.quantity || 1)}
                  </span>
                </div>

                {/* especialidades */}
                {item.specialties && item.specialties.length > 0 && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#555",
                      marginTop: 4,
                      marginLeft: 12,
                    }}
                  >
                    {item.specialties.map((sp, i) => (
                      <div key={i}>• {sp}</div>
                    ))}
                  </div>
                )}

                {/* notas */}
                {item.notes && (
                  <div
                    style={{
                      fontSize: "13px",
                      marginLeft: 12,
                      color: "#777",
                      fontStyle: "italic",
                      marginTop: 4,
                    }}
                  >
                    📝 {item.notes}
                  </div>
                )}
              </div>
            ))}

            {/* bebidas */}
            {drinkItems.length > 0 && (
              <div
                style={{
                  marginTop: 12,
                  paddingTop: 8,
                  borderTop: "1px dashed #ccc",
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    color: "#666",
                    fontWeight: "bold",
                    marginBottom: 6,
                  }}
                >
                  🥤 Bebidas
                </div>

                {drinkItems.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      fontSize: 13,
                      color: "#777",
                      marginLeft: 10,
                      marginBottom: 4,
                    }}
                  >
                    • {item.quantity || item.qty || 1}x{" "}
                    {item.name ||
                      item.product_name ||
                      item.product ||
                      item.title}
                  </div>
                ))}
              </div>
            )}
          </>
        ) : (
          <p style={{ marginLeft: 10 }}>Sin productos</p>
        )}
      </div>

      {/* notas generales */}
      {order.notes && (
        <div
          style={{
            marginTop: 10,
            padding: 8,
            background: "#fff7ed",
            borderRadius: 8,
            fontSize: 13,
            color: "#9a3412",
            fontWeight: "bold",
          }}
        >
          📝 {order.notes}
        </div>
      )}

      {/* botones */}
      <div style={{ marginTop: 10 }}>
        {order.status === "PENDING" && (
          <button onClick={() => handleUpdateStatus("PREPARING")}>
            👨‍🍳 Preparar
          </button>
        )}

        {order.status === "PREPARING" && (
          <button onClick={() => handleUpdateStatus("READY")}>
            🍕 Marcar listo
          </button>
        )}
      </div>
    </div>
  );
}

export default OrderCard;
